var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewSelection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16V22H8V20H4V16H2Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20V22H22V16H20V20H16Z",
    fill: "#647B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2V8H4V4H8V2H2Z",
    fill: "#647B8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4V8H22V2H16V4H20Z",
    fill: "#647B8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
    fill: "#647B8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78926 9.0857C7.92192 8.0153 9.65683 7 12 7C14.3432 7 16.0781 8.0153 17.2107 9.0857C17.7746 9.61853 18.198 10.1722 18.4858 10.6402C18.6294 10.8737 18.7455 11.0962 18.8295 11.2941C18.8936 11.4452 19 11.7179 19 12C19 12.2821 18.8936 12.5548 18.8295 12.7059C18.7455 12.9038 18.6294 13.1263 18.4858 13.3598C18.198 13.8278 17.7746 14.3815 17.2107 14.9143C16.0781 15.9847 14.3432 17 12 17C9.65683 17 7.92192 15.9847 6.78926 14.9143C6.22544 14.3815 5.80201 13.8278 5.51422 13.3598C5.37062 13.1263 5.25445 12.9038 5.17051 12.7059C5.10643 12.5548 5 12.2821 5 12C5 11.7179 5.10643 11.4452 5.17051 11.2941C5.25445 11.0962 5.37062 10.8737 5.51422 10.6402C5.80201 10.1722 6.22544 9.61853 6.78926 9.0857ZM7.04571 12C7.08522 11.9173 7.14182 11.8115 7.21786 11.6879C7.42012 11.359 7.73474 10.944 8.16296 10.5393C9.01437 9.7347 10.2795 9 12 9C13.7205 9 14.9856 9.7347 15.837 10.5393C16.2653 10.944 16.5799 11.359 16.7821 11.6879C16.8582 11.8115 16.9148 11.9173 16.9543 12C16.9148 12.0827 16.8582 12.1885 16.7821 12.3121C16.5799 12.641 16.2653 13.056 15.837 13.4607C14.9856 14.2653 13.7205 15 12 15C10.2795 15 9.01437 14.2653 8.16296 13.4607C7.73474 13.056 7.42012 12.641 7.21786 12.3121C7.14182 12.1885 7.08522 12.0827 7.04571 12ZM17.0173 12.1526L17.0168 12.1511L17.0151 12.1448L17.0164 12.149C17.0171 12.1515 17.0173 12.1526 17.0173 12.1526ZM17.0162 11.851L17.0151 11.8552C17.0168 11.8498 17.0173 11.8474 17.0173 11.8474C17.0173 11.8474 17.0168 11.8486 17.0162 11.851Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSelection);
export default __webpack_public_path__ + "static/media/view-selection.b284aa67.svg";
export { ForwardRef as ReactComponent };